/** @deprecated use ACTOR_TYPE instead */
const USER_ROLES = {
    superAdmin: 1,
    doctor: 2,
    patient: 3,
    ml: 4,
    pharmacist: 5,
    admin: 6,
    ptxSupportPartner: 7,
};
export default USER_ROLES;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlclJvbGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy91c2VyUm9sZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEseUNBQXlDO0FBQ3pDLE1BQU0sVUFBVSxHQUFjO0lBQzVCLFVBQVUsRUFBRSxDQUFDO0lBQ2IsTUFBTSxFQUFFLENBQUM7SUFDVCxPQUFPLEVBQUUsQ0FBQztJQUNWLEVBQUUsRUFBRSxDQUFDO0lBQ0wsVUFBVSxFQUFFLENBQUM7SUFDYixLQUFLLEVBQUUsQ0FBQztJQUNSLGlCQUFpQixFQUFFLENBQUM7Q0FDWixDQUFDO0FBRVgsZUFBZSxVQUFVLENBQUMifQ==